/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['assets/js/common/router/index', 'assets/js/modules/AjaxOperation'], function(router, AjaxOperation) {
    var API_GET_PRODUCT_TEMPLATES = '/api/products/{slug}/gallery-templates';
    var API_GET_PRODUCT_TEMPLATES_BY_NAME = '/api/products/{slug}/gallery-templates/{name}';

    return {
        getProductTemplates: function() {
            return new AjaxOperation(
                {
                    name: 'Get Product Templates'
                },
                {
                    type: 'get',
                    url: function() {
                        var params = {
                            slug: this.getObject().slug
                        };
                        if (this.getObject().page) {
                            params.page = this.getObject().page;
                        }
                        if (this.getObject().limit) {
                            params.limit = this.getObject().limit;
                        }
                        if (this.getObject().orientation) {
                            params.orientation = this.getObject().orientation;
                        }
                        if (this.getObject().name) {
                            params.name = this.getObject().name;
                            return router.generate(API_GET_PRODUCT_TEMPLATES_BY_NAME, params);
                        }
                        return router.generate(API_GET_PRODUCT_TEMPLATES, params);
                    },
                    data: {}
                }
            );
        },

        API_GET_PRODUCT_TEMPLATES: API_GET_PRODUCT_TEMPLATES
    };
});
